import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _followMemberRequest = {};
var _followMemberResponse = {};
var _listMemberFollowersRequest = {};
var _listMemberFollowersResponse = {};
var _listMemberFollowingRequest = {};
var _listMemberFollowingResponse = {};
var _listMyMemberFollowersRequest = {};
var _listMyMemberFollowersResponse = {};
var _listMyMemberFollowingRequest = {};
var _listMyMemberFollowingResponse = {};
var _queryMemberConnectionsRequest = {};
var _queryMemberConnectionsResponse = {};
var _queryMyMemberConnectionsRequest = {};
var _queryMyMemberConnectionsResponse = {};
var _unfollowMemberRequest = {};
var _unfollowMemberResponse = {};
function resolveComWixpressMembersFollowV3MemberFollowersUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
            {
                srcPath: '/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v3/followers',
                destPath: '/v3/followers',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Sets the current member to follow another, specified member. */
export function followMember(payload) {
    var _a = serializer(_followMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_followMemberResponse, {}).fromJSON;
    function __followMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'POST',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.FollowMember',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __followMember.fromReq = fromReq;
    __followMember.__isAmbassador = true;
    return __followMember;
}
/** Sets the current member to unfollow another, specified member. */
export function unfollowMember(payload) {
    var _a = serializer(_unfollowMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unfollowMemberResponse, {}).fromJSON;
    function __unfollowMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.UnfollowMember',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unfollowMember.fromReq = fromReq;
    __unfollowMember.__isAmbassador = true;
    return __unfollowMember;
}
/** Retrieves a list of members who are followed by the current member. */
export function listMyMemberFollowing(payload) {
    var _a = serializer(_listMyMemberFollowingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMyMemberFollowingResponse, {}).fromJSON;
    function __listMyMemberFollowing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'GET',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.ListMyMemberFollowing',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/my/following',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMyMemberFollowing.fromReq = fromReq;
    __listMyMemberFollowing.__isAmbassador = true;
    return __listMyMemberFollowing;
}
/** Retrieves a list of members who are followed by the given member. */
export function listMemberFollowing(payload) {
    var _a = serializer(_listMemberFollowingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMemberFollowingResponse, {}).fromJSON;
    function __listMemberFollowing(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'GET',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.ListMemberFollowing',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/{memberId}/following',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMemberFollowing.fromReq = fromReq;
    __listMemberFollowing.__isAmbassador = true;
    return __listMemberFollowing;
}
/** Retrieves a list of members who are following the current member. */
export function listMyMemberFollowers(payload) {
    var _a = serializer(_listMyMemberFollowersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMyMemberFollowersResponse, {}).fromJSON;
    function __listMyMemberFollowers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'GET',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.ListMyMemberFollowers',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMyMemberFollowers.fromReq = fromReq;
    __listMyMemberFollowers.__isAmbassador = true;
    return __listMyMemberFollowers;
}
/** Retrieves a list of members who are following the given member. */
export function listMemberFollowers(payload) {
    var _a = serializer(_listMemberFollowersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMemberFollowersResponse, {}).fromJSON;
    function __listMemberFollowers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'GET',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.ListMemberFollowers',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMemberFollowers.fromReq = fromReq;
    __listMemberFollowers.__isAmbassador = true;
    return __listMemberFollowers;
}
/** Retrieves a list of members and their connections to the current member. */
export function queryMyMemberConnections(payload) {
    var _a = serializer(_queryMyMemberConnectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMyMemberConnectionsResponse, {}).fromJSON;
    function __queryMyMemberConnections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'POST',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.QueryMyMemberConnections',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/my/connections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMyMemberConnections.fromReq = fromReq;
    __queryMyMemberConnections.__isAmbassador = true;
    return __queryMyMemberConnections;
}
/**
 * Retrieves a list of members and their connections to the given member.
 * > **Note:** If an empty array is passed as `connectedMemberIds`, the call will succeed, but it will not return any data.
 */
export function queryMemberConnections(payload) {
    var _a = serializer(_queryMemberConnectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMemberConnectionsResponse, {}).fromJSON;
    function __queryMemberConnections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v3.follow',
            method: 'POST',
            methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.QueryMemberConnections',
            url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
                protoPath: '/v3/followers/{memberId}/connections',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMemberConnections.fromReq = fromReq;
    __queryMemberConnections.__isAmbassador = true;
    return __queryMemberConnections;
}
//# sourceMappingURL=http.impl.js.map